import React from "react";
import { ReactSVG } from "react-svg";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import MedicationNameToolTip from "../../../../common/tooltip/medication-name";
import NewToolTip from "../../../../common/New-ToolTip";
import { getFullLabelByValue } from "../../service-steps/clinical-assessment/data";
import { useSelector } from "react-redux";
import { GetDropDownValue, GetMultiDropDownValue } from "../../../../forms/components/data";
import { reasonOptions, sourceOptions } from "../../../create/options";
import { hasActiveInterventionLink } from "../../../Patient-Menu/Interventions/data";

const AMRPostReviewList = ({
  medications,
  selectMedication,
  getDrugFromCard,
  showInterventionIcon = false,
  isDiscontinued = false,
  expandedDiscontinued = [],
  toggleDiscontinuedExpansion,
}) => {
  if (!medications || medications.length === 0) {
    return null;
  }

  const interventions = useSelector((state) => state.intervention.interventions || []);
  const hasInterventionLink = (record) =>
    hasActiveInterventionLink(record, interventions);

  return (
    <ul className="overflow-y-auto">
      {medications.map((med, i) => (
        <li
          key={isDiscontinued ? med.id : i}
          onClick={() => {
            if (!isDiscontinued) {
              selectMedication(getDrugFromCard(med));
            }
          }}
        >
          <div
            className={`cursor-pointer px-2 flex items-center ${
              isDiscontinued ? "justify-between" : "justify-start"
            } h-[36px]`}
          >
            <div className="flex items-center flex-1 min-w-0">
              <div className="flex-shrink-0">
                {isDiscontinued ? (
                  <ReactSVG
                    src={`/icons/undo.svg`}
                    className={`flex text-red-50 w-6`}
                  />
                ) : showInterventionIcon ? (
                  <ReactSVG
                    src={`/icons/intervention-sm.svg`}
                    className={`flex text-black w-6`}
                  />
                ) : hasInterventionLink(med) ? (
                  <ReactSVG
                    src={`/icons/intervention-sm.svg`}
                    className={`flex text-black w-6`}
                  />
                ) : (
                  <ReactSVG
                    src={`/icons/correct-tick-sm2.svg`}
                    className={`flex text-black w-6`}
                  />
                )}
              </div>
              <span
                className="px-[10px] block truncate flex-1 min-w-0"
                data-tooltip-place="bottom"
                data-tooltip-id={isDiscontinued ? med.displayName : med.name}
              >
                {(isDiscontinued ? med.displayName : med.name).length > 30
                  ? (isDiscontinued ? med.displayName : med.name).slice(0, 30) + "..."
                  : isDiscontinued ? med.displayName : med.name}{" "}
              </span>
            </div>
            {isDiscontinued && (
              <button
                className="px-2"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDiscontinuedExpansion(med.id);
                }}
              >
                {expandedDiscontinued.includes(med.id) ? (
                  <ChevronUpIcon className="w-4 h-4" />
                ) : (
                  <ChevronDownIcon className="w-4 h-4" />
                )}
              </button>
            )}
          </div>

          {isDiscontinued && expandedDiscontinued.includes(med.id) && (
            <div className="p-3 text-xs bg-gray-50 border-t border-gray-200">
              <div className="flex flex-col">
                <div className="flex">
                  <p className="font-bold mr-2">Source for communication:</p>
                  <p>{GetMultiDropDownValue(sourceOptions, med.inactiveInitiator) || "Not specified"}</p>
                </div>
                <div className="flex mt-1">
                  <p className="font-bold mr-2">Reason for discontinue:</p>
                  <p>{GetDropDownValue(reasonOptions, med.inactiveReason) || "Not specified"}</p>
                </div>
              </div>
            </div>
          )}

          {(isDiscontinued ? med.displayName : med.name).length > 30 && (
            <NewToolTip
              id={isDiscontinued ? med.displayName : med.name}
              render={() => (
                <MedicationNameToolTip
                  name={isDiscontinued ? med.displayName : med.name}
                />
              )}
            />
          )}
        </li>
      ))}
    </ul>
  );
};

export default AMRPostReviewList;
